<template>
  <div class="loading_screen" title="Please wait..." :style="'height:' + expectedHeight + 'px'">
      <Icon icon="spinner fa-spin" />
      <p style="margin-top:20px;font-size:20px;">Loading</p>
  </div>
</template>

<script>
export default {
    props: {
        expectedHeight: {
            type: Number,
            default: 100
        }
    }
}
</script>

<style scoped>
.loading_screen {
    font-size: 30px;
    text-align: center;
}
</style>